// Firebase Configuration
export const firebaseConfig = {
  apiKey: "AIzaSyBVL9JeD2Ru2tKEmHVKb9xnZw_ma33ad3o",
  authDomain: "flashai-c2b4b.firebaseapp.com",
  projectId: "flashai-c2b4b",
  storageBucket: "flashai-c2b4b.appspot.com",
  messagingSenderId: "701537702425",
  appId: "1:701537702425:web:flashcard-app-dev"
};

// Instructions:
// 1. Go to https://console.firebase.google.com/
// 2. Create a new project or select an existing one
// 3. Go to Project Settings > General
// 4. Scroll down to "Your apps" and click "Add app" (Web app)
// 5. Copy the configuration values and replace the values above
// 6. Enable Authentication in Firebase Console:
//    - Go to Authentication > Sign-in method
//    - Enable "Email/Password" provider
// 7. Update the AuthContext.js file with your configuration